import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import {
  Evaluator,
  EvaluatorForStudent,
  JobDetails,
  Mentee,
  Mentor,
  Student,
  StudentForEvaluator,
} from '@app/app/page-modules/admin/components/mentors/admin-mentors.model';
import { JobsTimelineDialogComponent } from '../jobs-timeline-dialog/jobs-timeline-dialog.component';

export type TableDataItem = Mentor | Mentee | Evaluator | Student | StudentForEvaluator | EvaluatorForStudent;

@Component({
  selector: 'ptl-mentor-mentee-table',
  templateUrl: './mentor-mentee-table.component.html',
  styleUrls: ['./mentor-mentee-table.component.scss'],
})
export class MentorMenteeTableComponent implements OnInit, OnChanges {
  @Input() data: TableDataItem[] = [];
  @Input() displayedColumns: string[] = [];
  @Input() viewMode: 'mentors' | 'mentees' | 'supervisors' | 'students' = 'mentors';
  @Input() isMyHub = false;

  @Output() viewDetails = new EventEmitter<TableDataItem>();
  @Output() sortChange = new EventEmitter<Sort>();

  processedData: TableDataItem[] = [];

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this.processData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] || changes['entityType']) {
      this.processData();
    }
  }

  isPendingApproval(user: TableDataItem): boolean {
    return this.isMyHub && this.viewMode === 'mentors' && 'status' in user && user.status === 'PENDING';
  }

  updateTable(newData: TableDataItem[]) {
    this.data = [...newData];
  }

  processData(): void {
    this.processedData = this.data ? [...this.data] : [];
  }

  onSortChange(sort: Sort) {
    this.sortChange.emit(sort);
  }

  openJobsDialog(user: TableDataItem): void {
    if ('jobs' in user && user.jobs?.length) {
      this.dialog.open(JobsTimelineDialogComponent, {
        data: {
          userName: `${user.firstName} ${user.lastName}`,
          jobs: user.jobs,
        },
        width: '500px',
        maxHeight: '80vh',
      });
    }
  }

  getActiveJob(jobs: JobDetails[] | null | undefined): JobDetails | null {
    if (!jobs?.length) {
      return null;
    }

    return jobs.find((job) => this.isJobActive(job)) ?? null;
  }

  hasActiveJob(jobs: JobDetails[] | null | undefined): boolean {
    return !!this.getActiveJob(jobs);
  }

  isJobActive(job: JobDetails): boolean {
    if (!job.endDate) {
      return true;
    }
    return new Date(job.endDate) >= new Date();
  }

  getMostRecentJob(jobs: JobDetails[]): JobDetails {
    return [...jobs].sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())[0];
  }
}
